<template>
  <div class="login">
    <div class="title">绑定用户</div>
    <div class="login-form">
      <form action="#">
        <div class="user-name common-div">
          <span class="eamil-icon common-icon">
            <i class="icon">&#xe601;</i>
          </span>
          <input type="text" name="username" v-model="username" placeholder="用户名" />        
        </div>
        <div class="user-pasw common-div">
          <span class="pasw-icon common-icon">
            <i class="icon">&#xe687;</i>
          </span>
          <input type="password" name="password" v-model="password" placeholder="密码" />        
        </div>
        <div class="login-btn" @click="_login">绑定</div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../fetch/api";
import * as _ from "../util/tool";
import * as types from '../vuex/types';

export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed:{
    ssoBindAccount: {
      // getter
      get: function () {
          return this.$route.query.ssoBindAccount;
      }
    },
    pageParamsType: {
      // getter
      get: function () {
          return this.$route.query.type;
      }
    }
  },
  methods: {
    ...mapActions({}),
    // 用户绑定
    _login() {
      if (!this.username || !this.password) {
        _.alert("请填写完整");
        return;
      }
      let data = {
        userName: this.username,
        password: this.password,
        ssoAccount: this.ssoBindAccount
      };
      console.log(data)
      this.$store.dispatch("setLoadingState", true);
      
      api
        .ssoBindAccount(data)
        .then(res => {
          console.log(res);
          if (res.success) {
            this.$store.dispatch("setLoadingState", false);
            sessionStorage.setItem("token", res.result.token);
            console.log(this.pageParamsType)
            this.$router.push("indexMenuJointQuery");
          }
        })
        .catch(error => {
          this.$store.dispatch("setLoadingState", false);
          _.alert(error.data.msg);
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
.login {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
  padding-bottom: px2rem(260px);
  .title {
    width: 100%;
    height: auto;
    overflow: hidden;
    font-size: px2rem(40px);
    text-align: center;
    height: px2rem(300px);
    line-height: px2rem(300px);
    color: #333;
  }
  .login-form {
    width: px2rem(600px);
    height: auto;
    margin: 0 auto;
    .common-div {
      width: 100%;
      height: px2rem(80px);
      overflow: hidden;
      border-radius: 4px;
      margin-bottom: px2rem(50px);
      -moz-box-shadow:5px 5px 10px #d2d2d2; 
      -webkit-box-shadow:5px 5px 10px #d2d2d2; 
      box-shadow:5px 5px 10px #d2d2d2;
      > .common-icon {
        float: left;
        width: px2rem(40px);
        height: px2rem(40px);
        line-height: px2rem(40px);
        overflow: hidden;
        margin: px2rem(20px);
        text-align: center;
        img {
          width: 100%;
          height: auto;
        }
      }
      > input {
        float: left;
        line-height: px2rem(80px);
        background-color: transparent;
        border: none;
        outline: none;
        font-size: 16px;
        color: #333;
      }
    }
    .user-name,
    .user-pasw {
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 5px 5px 10px #d2d2d2;
    }
    .login-btn {
      background-color: #0bd38a;
      color: #fff;
      font-size: px2rem(28px);
      text-align: center;
      height: px2rem(100px);
      line-height: px2rem(100px);
      margin-bottom: px2rem(50px);
      border-radius: 4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// bindingPageJointQuery.vue?6bacd7eb